// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActivityBellController from "./activity_bell_controller"
application.register("activity-bell", ActivityBellController)

import AppConfirmFormController from "./app_confirm_form_controller"
application.register("app-confirm-form", AppConfirmFormController)

import ApprovalReminderController from "./approval_reminder_controller"
application.register("approval-reminder", ApprovalReminderController)

import ArchiveButtonController from "./archive_button_controller"
application.register("archive-button", ArchiveButtonController)

import AssignmentPickerController from "./assignment_picker_controller"
application.register("assignment-picker", AssignmentPickerController)

import AutoFilterController from "./auto_filter_controller"
application.register("auto-filter", AutoFilterController)

import AutosaveFieldController from "./autosave_field_controller"
application.register("autosave-field", AutosaveFieldController)

import AvatarStackController from "./avatar_stack_controller"
application.register("avatar-stack", AvatarStackController)

import BmtCalendarController from "./bmt_calendar_controller"
application.register("bmt-calendar", BmtCalendarController)

import BrandStrategyFormController from "./brand_strategy_form_controller"
application.register("brand-strategy-form", BrandStrategyFormController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import InternTaskBulkController from "./intern_task_bulk_controller"
application.register("intern-task-bulk", InternTaskBulkController)

import RepeatFieldsController from "./repeat_fields_controller"
application.register("repeat-fields", RepeatFieldsController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)


import CampaignFormController from "./campaign_form_controller"
application.register("campaign-form", CampaignFormController)

import CampaignOptimizerController from "./campaign_optimizer_controller"
application.register("campaign-optimizer", CampaignOptimizerController)

import CaptionWriterController from "./caption_writer_controller"
application.register("caption-writer", CaptionWriterController)

import CheckInController from "./check_in_controller"
application.register("check-in", CheckInController)
import CheckInNoticeController from "./check_in_notice_controller"
application.register("check-in-notice", CheckInNoticeController)

import ClientContactDupeController from "./client_contact_dupe_controller"
application.register("client-contact-dupe", ClientContactDupeController)

import SptArtistToolsFormController from "./spt_artist_tools_form_controller"
application.register("spt-artist-tools-form", SptArtistToolsFormController)

import SptCuratorDupeController from "./spt_curator_dupe_controller"
application.register("spt-curator-dupe", SptCuratorDupeController)
import SmsRetryController from "./sms_retry_controller"
application.register("sms-retry", SmsRetryController)
import PressReleaseBuilderController from "./press_release_builder_controller"
application.register("press-release-builder", PressReleaseBuilderController)
import PressSendProgressController from "./press_send_progress_controller"
application.register("press-send-progress", PressSendProgressController)
import TinymceEditorController from "./tinymce_editor_controller"
application.register("tinymce-editor", TinymceEditorController)

import ClientDepartmentWarningController from "./client_department_warning_controller"
application.register("client-department-warning", ClientDepartmentWarningController)

import ClientEmailsController from "./client_emails_controller"
application.register("client-emails", ClientEmailsController)

import ClientFieldsController from "./client_fields_controller"
application.register("client-fields", ClientFieldsController)

import ClientLeadSyncController from "./client_lead_sync_controller"
application.register("client-lead-sync", ClientLeadSyncController)

import ClientFormController from "./client_form_controller"
application.register("client-form", ClientFormController)

import ClipCopyController from "./clip_copy_controller"
application.register("clip-copy", ClipCopyController)

import ClipDeleteController from "./clip_delete_controller"
application.register("clip-delete", ClipDeleteController)

import ClipMoveController from "./clip_move_controller"
application.register("clip-move", ClipMoveController)

import ClippingEditorController from "./clipping_editor_controller"
application.register("clipping-editor", ClippingEditorController)

import ConversationController from "./conversation_controller"
application.register("conversation", ConversationController)
import ClientPickerController from "./client_picker_controller"
application.register("client-picker", ClientPickerController)
import FilesPickerController from "./files_picker_controller"
application.register("files-picker", FilesPickerController)
import EndpointFieldsController from "./endpoint_fields_controller"
application.register("endpoint-fields", EndpointFieldsController)
import ListFilterController from "./list_filter_controller"
application.register("list-filter", ListFilterController)

import ConfirmActionController from "./confirm_action_controller"
application.register("confirm-action", ConfirmActionController)

import NonContactAssignController from "./non_contact_assign_controller"
application.register("non-contact-assign", NonContactAssignController)

import ReleaseInlineEditController from "./release_inline_edit_controller"
application.register("release-inline-edit", ReleaseInlineEditController)

import ClientFilterController from "./client_filter_controller"
application.register("client-filter", ClientFilterController)

import ReleaseFormController from "./release_form_controller"
application.register("release-form", ReleaseFormController)

import ReleaseQuickAnswerController from "./release_quick_answer_controller"
application.register("release-quick-answer", ReleaseQuickAnswerController)

import ReleaseDaySortController from "./release_day_sort_controller"
application.register("release-day-sort", ReleaseDaySortController)

import DistributorSelectController from "./distributor_select_controller"
application.register("distributor-select", DistributorSelectController)

import ReleaseHideController from "./release_hide_controller"
import SptFxAmountController from "./spt_fx_amount_controller"
application.register("release-hide", ReleaseHideController)
application.register("spt-fx-amount", SptFxAmountController)

import ReleaseNotesController from "./release_notes_controller"
application.register("release-notes", ReleaseNotesController)

import ReleaseLinkGuardController from "./release_link_guard_controller"
application.register("release-link-guard", ReleaseLinkGuardController)

import SpecialPermissionsController from "./special_permissions_controller"
application.register("special-permissions", SpecialPermissionsController)

import ReleaseReportSendController from "./release_report_send_controller"
application.register("release-report-send", ReleaseReportSendController)

import ContactEmailActivityController from "./contact_email_activity_controller"
application.register("contact-email-activity", ContactEmailActivityController)

import ContentIdeasController from "./content_ideas_controller"
application.register("content-ideas", ContentIdeasController)

import ContractReminderController from "./contract_reminder_controller"
application.register("contract-reminder", ContractReminderController)
import MediaMonitoringPromptController from "./media_monitoring_prompt_controller"
application.register("media-monitoring-prompt", MediaMonitoringPromptController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import CredentialRevealController from "./credential_reveal_controller"
application.register("credential-reveal", CredentialRevealController)

import CropController from "./crop_controller"
application.register("crop", CropController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import DayViewController from "./day_view_controller"
application.register("day-view", DayViewController)

import DeleteConfirmController from "./delete_confirm_controller"
application.register("delete-confirm", DeleteConfirmController)

import AddressCheckController from "./address_check_controller"
application.register("address-check", AddressCheckController)
import KeywordCheckController from "./keyword_check_controller"
application.register("keyword-check", KeywordCheckController)

import AddressNoticeController from "./address_notice_controller"
application.register("address-notice", AddressNoticeController)

import EmailVerificationController from "./email_verification_controller"
application.register("email-verification", EmailVerificationController)

import ImportEmailCheckController from "./import_email_check_controller"
application.register("import-email-check", ImportEmailCheckController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import EmailComposerController from "./email_composer_controller"
application.register("email-composer", EmailComposerController)

import EngagementCompletionController from "./engagement_completion_controller"
application.register("engagement-completion", EngagementCompletionController)

import FilesUploadController from "./files_upload_controller"
application.register("files-upload", FilesUploadController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FlashToastController from "./flash_toast_controller"
application.register("flash-toast", FlashToastController)

import GenrePickerController from "./genre_picker_controller"
application.register("genre-picker", GenrePickerController)

import GoogleCalendarController from "./google_calendar_controller"
application.register("google-calendar", GoogleCalendarController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InboxController from "./inbox_controller"
application.register("inbox", InboxController)

import InlineCellController from "./inline_cell_controller"
application.register("inline-cell", InlineCellController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InternNotesController from "./intern_notes_controller"
application.register("intern-notes", InternNotesController)

import InternTaskCreateController from "./intern_task_create_controller"
application.register("intern-task-create", InternTaskCreateController)

import InternTaskKeyboardController from "./intern_task_keyboard_controller"
application.register("intern-task-keyboard", InternTaskKeyboardController)

import InternTaskRowController from "./intern_task_row_controller"
application.register("intern-task-row", InternTaskRowController)

import JobQueueController from "./job_queue_controller"
application.register("job-queue", JobQueueController)

import LocationGrantRowController from "./location_grant_row_controller"
application.register("location-grant-row", LocationGrantRowController)

import LocationGrantsController from "./location_grants_controller"
application.register("location-grants", LocationGrantsController)

import MainController from "./main_controller"
application.register("main", MainController)

import MessagesController from "./messages_controller"
application.register("messages", MessagesController)


import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiFilterController from "./multi_filter_controller"
application.register("multi-filter", MultiFilterController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NotesController from "./notes_controller"
application.register("notes", NotesController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import OutreachDeskRowController from "./outreach_desk_row_controller"
application.register("outreach-desk-row", OutreachDeskRowController)

import PanelFormController from "./panel_form_controller"
application.register("panel-form", PanelFormController)

import PaymentFormController from "./payment_form_controller"
application.register("payment-form", PaymentFormController)

import PeoplePopupController from "./people_popup_controller"
application.register("people-popup", PeoplePopupController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PhotoTrashController from "./photo_trash_controller"
application.register("photo-trash", PhotoTrashController)

import PitchListController from "./pitch_list_controller"
application.register("pitch-list", PitchListController)

import PlacementEditController from "./placement_edit_controller"
application.register("placement-edit", PlacementEditController)

import PlaylistImportController from "./playlist_import_controller"
application.register("playlist-import", PlaylistImportController)

import PlaylistUrlResolverController from "./playlist_url_resolver_controller"
application.register("playlist-url-resolver", PlaylistUrlResolverController)

import PostingQueueController from "./posting_queue_controller"
application.register("posting-queue", PostingQueueController)

import PressClipEditorController from "./press_clip_editor_controller"
application.register("press-clip-editor", PressClipEditorController)

// Send to TEAM (Send_To_TEAM_Plan.md): the small window the bookmarks-bar
// button opens, and the install button itself.
import SendToTeamController from "./send_to_team_controller"
application.register("send-to-team", SendToTeamController)
import SendToTeamButtonController from "./send_to_team_button_controller"
application.register("send-to-team-button", SendToTeamButtonController)

import PressClipsController from "./press_clips_controller"
application.register("press-clips", PressClipsController)

import PressReleasesController from "./press_releases_controller"
application.register("press-releases", PressReleasesController)

import DpkSectionController from "./dpk_section_controller"
application.register("dpk-section", DpkSectionController)

import DpkSongPlayerController from "./dpk_song_player_controller"
application.register("dpk-song-player", DpkSongPlayerController)

import PriorityToggleController from "./priority_toggle_controller"
application.register("priority-toggle", PriorityToggleController)

import ProfileAttachmentController from "./profile_attachment_controller"
application.register("profile-attachment", ProfileAttachmentController)

import PrtModalController from "./prt_modal_controller"
application.register("prt-modal", PrtModalController)

import PrtQuickInfoController from "./prt_quick_info_controller"
application.register("prt-quick-info", PrtQuickInfoController)

import PrtRichTextEditorController from "./prt_rich_text_editor_controller"
application.register("prt-rich-text-editor", PrtRichTextEditorController)


import PrtTabsController from "./prt_tabs_controller"
application.register("prt-tabs", PrtTabsController)

import QuickInfoController from "./quick_info_controller"
application.register("quick-info", QuickInfoController)



import ReleaseExpandController from "./release_expand_controller"
application.register("release-expand", ReleaseExpandController)

import RepurposeController from "./repurpose_controller"
application.register("repurpose", RepurposeController)

import ResultsFilterController from "./results_filter_controller"
application.register("results-filter", ResultsFilterController)

import ReviewKeysController from "./review_keys_controller"
application.register("review-keys", ReviewKeysController)

import RichTextEditorController from "./rich_text_editor_controller"
application.register("rich-text-editor", RichTextEditorController)

import RowToggleController from "./row_toggle_controller"
application.register("row-toggle", RowToggleController)

import SaveOutletModalController from "./save_outlet_modal_controller"
application.register("save-outlet-modal", SaveOutletModalController)

import ScheduleGridController from "./schedule_grid_controller"
application.register("schedule-grid", ScheduleGridController)

import ScreenshotPreviewController from "./screenshot_preview_controller"
application.register("screenshot-preview", ScreenshotPreviewController)

import SidePanelController from "./side_panel_controller"
application.register("side-panel", SidePanelController)


import SmartSearchController from "./smart_search_controller"
application.register("smart-search", SmartSearchController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SptRangeCalendarController from "./spt_range_calendar_controller"
application.register("spt-range-calendar", SptRangeCalendarController)

import SptRecipientChipsController from "./spt_recipient_chips_controller"
application.register("spt-recipient-chips", SptRecipientChipsController)

import SptSendConfirmController from "./spt_send_confirm_controller"
application.register("spt-send-confirm", SptSendConfirmController)

import SptSibylController from "./spt_sibyl_controller"
application.register("spt-sibyl", SptSibylController)


import StatusPillController from "./status_pill_controller"
application.register("status-pill", StatusPillController)

import StoryEditorController from "./story_editor_controller"
application.register("story-editor", StoryEditorController)

import SubmithubSettingsController from "./submithub_settings_controller"
application.register("submithub-settings", SubmithubSettingsController)

import SubmithubVerificationController from "./submithub_verification_controller"
application.register("submithub-verification", SubmithubVerificationController)

import SupportTicketController from "./support_ticket_controller"
application.register("support-ticket", SupportTicketController)

import TrendingCheckController from "./trending_check_controller"
application.register("trending-check", TrendingCheckController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TaskSortableController from "./task_sortable_controller"
application.register("task-sortable", TaskSortableController)

import TasksController from "./tasks_controller"
application.register("tasks", TasksController)

import TeamContactsController from "./team_contacts_controller"
application.register("team-contacts", TeamContactsController)

import TemplateFormController from "./template_form_controller"
application.register("template-form", TemplateFormController)

import TemplateSelectorController from "./template_selector_controller"
application.register("template-selector", TemplateSelectorController)

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)

import TiptapEditorController from "./tiptap_editor_controller"
application.register("tiptap-editor", TiptapEditorController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleRoleController from "./toggle_role_controller"
application.register("toggle-role", ToggleRoleController)

import TrackUploadController from "./track_upload_controller"
application.register("track-upload", TrackUploadController)

import TriageKeysController from "./triage_keys_controller"
application.register("triage-keys", TriageKeysController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import UploadProgressController from "./upload_progress_controller"
application.register("upload-progress", UploadProgressController)

import VetKeysController from "./vet_keys_controller"
application.register("vet-keys", VetKeysController)

import WeeklyUpdateController from "./weekly_update_controller"
application.register("weekly-update", WeeklyUpdateController)

import PhoneCopyController from "./phone_copy_controller"
application.register("phone-copy", PhoneCopyController)

import PhoneDatesController from "./phone_dates_controller"
application.register("phone-dates", PhoneDatesController)

import PhoneHoursController from "./phone_hours_controller"
application.register("phone-hours", PhoneHoursController)

import PushSubscribeController from "./push_subscribe_controller"
application.register("push-subscribe", PushSubscribeController)

import ShellController from "./shell_controller"
application.register("shell", ShellController)
